import { COMPONENT_HEIGHTS, CYCLE_TYPOGRAPHY, Colors } from '@amelio/ui-library';

import type { FormFieldProps } from '@/components/FormField/FormField';
import type { DateFieldAppearance } from '@/pages/ManagerAssessment/Evaluation/components/EvaluationDatePeriod';

const CYCLE_FIELD_LABEL: Pick<FormFieldProps, 'spacing' | 'labelClassName' | 'labelColor'> = {
    spacing: 'snug',
    labelClassName: CYCLE_TYPOGRAPHY.overline,
    labelColor: Colors.STEP_RAIL_MUTED,
};

const CYCLE_FIELD_IDLE_BORDER = 'border-step-rail-track';

const CYCLE_DATE_FIELD_CHROME: DateFieldAppearance = {
    variant: 'violet',
    iconPlacement: 'leading',
    valueTextClassName: CYCLE_TYPOGRAPHY.body,
    idleBorderClassName: CYCLE_FIELD_IDLE_BORDER,
    placeholderTextClassName: 'text-base-400',
    clearAppearance: 'onHover',
    hideFocusBorderWhenOpen: true,
    heightClassName: COMPONENT_HEIGHTS.mdPlus,
};

export { CYCLE_FIELD_LABEL, CYCLE_FIELD_IDLE_BORDER, CYCLE_DATE_FIELD_CHROME };
